export const IS_GC_PAYMENT_METHOD = 'IS_GC_PAYMENT_METHOD';

export enum PaymentMethodTypes {
  CREDIT_OR_DEBIT = 'scheme',
  PAYPAL = 'paypal',
  GOOGLE_PAY = 'googlepay',
  APPLE_PAY = 'applepay',
  GIFT_CARD = 'giftcard',
  KLARNA = 'klarna',
  KLARNA_ACCOUNT = 'klarna_account',
}
